import { render } from "./channelControlDialog.vue?vue&type=template&id=6e723550&scoped=true"
import script from "./channelControlDialog.vue?vue&type=script&lang=js"
export * from "./channelControlDialog.vue?vue&type=script&lang=js"

import "./channelControlDialog.vue?vue&type=style&index=0&id=6e723550&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e723550"]])

export default __exports__